import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import styles from './about-slogan.module.scss'

export default function AboutSlogan (props) {
  return (
    <div className={styles['about-slogan']}>
      <div className='container-fluid'>
        <Row>
          <h2 className={styles['about-slogan__title']}>WHAT THE EXPERTS ARE SAYING</h2>
          <Col xs={12} md={5} className={styles['about-slogan__item-1']}>
            "Mike Dolce is an expert in training and nutrition." <span className={styles['about-slogan__author']}>- MensFitness</span>
          </Col>
          <Col xs={12} md={3} className={styles['about-slogan__item-2']}>
            "A lifestyle changer" <span className={styles['about-slogan__author']}>- ESPN</span>
          </Col>
          <Col xs={12} md={4} className={styles['about-slogan__item-3']}>
            "Mike Dolce is the best in the business" <span className={styles['about-slogan__author']}>- Chael Sonnen</span>
          </Col>
        </Row>
      </div>
    </div>
  )
}
